export default function(cities = [], action) {
    if(action.type === "addCitiesFromMap") {
        var newCities = action.whatCities;
        return newCities
    }else {
        return cities
    }
}